export default "__VITE_ASSET__CgfT55qb__"